import { SPECIAL_CURRENCY_ID } from '@/types/shared/player'
import FeatherImageRotated from '@/assets/images/feather-rotated.png'
import FeatherImage from '@/assets/images/feather.png'
import GoldenEggImage from '@/assets/images/special-currencies/golden-egg.png'
import CrownImage from '@/assets/images/special-currencies/crown.png'
import GemImage from '@/assets/images/special-currencies/gem.webp'
import KeyImage from '@/assets/images/special-currencies/key.png'
import ParachuteImage from '@/assets/images/special-currencies/parachute.webp'
import PlantImage from '@/assets/images/special-currencies/plant.png'
import TopHatImage from '@/assets/images/special-currencies/top-hat.png'
import HolidayOrbImage from '@/assets/images/special-currencies/dropeeorb.webp'

export const specialCurrenciesConfig: Record<SPECIAL_CURRENCY_ID, { label: string; image: string, image2: string }> = {
  [SPECIAL_CURRENCY_ID.GOLD_FEATHER]: {
    label: 'Feathers',
    image: FeatherImageRotated,
    image2: FeatherImage,
  },
  [SPECIAL_CURRENCY_ID.KEY]: {
    label: 'Keys',
    image: KeyImage,
    image2: '',
  },
  [SPECIAL_CURRENCY_ID.GEM]: {
    label: 'Gems',
    image: GemImage,
    image2: '',
  },
  [SPECIAL_CURRENCY_ID.GOLDEN_EGG]: {
    label: 'Eggs',
    image: GoldenEggImage,
    image2: '',
  },
  [SPECIAL_CURRENCY_ID.CROWN]: {
    label: 'Crowns',
    image: CrownImage,
    image2: '',
  },
  [SPECIAL_CURRENCY_ID.PARACHUTE]: {
    label: 'Parachutes',
    image: ParachuteImage,
    image2: '',
  },
  [SPECIAL_CURRENCY_ID.PLANT]: {
    label: 'Plants',
    image: PlantImage,
    image2: '',
  },
  [SPECIAL_CURRENCY_ID.TOP_HAT]: {
    label: 'Top Hats',
    image: TopHatImage,
    image2: '',
  },
  [SPECIAL_CURRENCY_ID.HOLIDAY_ORB]: {
    label: 'Holiday Orbs',
    image: HolidayOrbImage,
    image2: '',
  },
}